import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';

// Links each thread to the matching section of /shop/ (see public/shop/index.php
// for the section ids). Checked in order against the discussion title, so the
// more specific topics come first; anything unmatched links to the shop top.
const TOPICS = [
  { re: /dash ?cam|dvr/i, anchor: 'dash-cams', label: 'dash cams' },
  { re: /\bmats?\b|liner|boot|trunk|luggage/i, anchor: 'mats', label: 'floor mats & boot liners' },
  { re: /screen|display|protector/i, anchor: 'screen-protectors', label: 'screen protectors' },
  { re: /mud ?(flap|guard)|roof|rack|bars?\b|tow|deflector|visor/i, anchor: 'exterior', label: 'mudguards, roof bars & exterior parts' },
  { re: /seat|interior|cup ?holder|vent/i, anchor: 'interior', label: 'seat covers & interior upgrades' },
  { re: /\bkey\b|fob/i, anchor: 'key-covers', label: 'key covers' },
];

export function shopTarget(discussion) {
  const title = (discussion && discussion.title()) || '';
  const topic = TOPICS.find((t) => t.re.test(title));
  return topic
    ? { href: '/shop/#' + topic.anchor, label: 'Shop BYD ' + topic.label }
    : { href: '/shop/', label: 'Shop BYD accessories' };
}

export default function addShopLinks() {
  // Card under the opening post: visible on every device.
  extend(CommentPost.prototype, 'contentItems', function (items) {
    const post = this.attrs.post;
    if (!post || post.number() !== 1) return;

    const target = shopTarget(post.discussion());

    items.add(
      'byd-shop',
      <aside className="BYDShopCard">
        <i className="fas fa-shopping-bag BYDShopCard-icon" aria-hidden="true" />
        <div className="BYDShopCard-text">
          <strong>Accessories for your BYD</strong>
          <span>Parts and upgrades for the J5, J7 and J8 that owners recommend.</span>
        </div>
        <a className="Button Button--primary BYDShopCard-button" href={target.href}>
          {target.label}
        </a>
      </aside>,
      -100
    );
  });

  // Sidebar link under the Reply button (desktop; the sidebar is hidden on phones).
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    const discussion = this.discussion;
    if (!discussion) return;

    const target = shopTarget(discussion);

    items.add(
      'byd-shop',
      <a className="Button BYDShopSidebar" href={target.href}>
        <i className="fas fa-shopping-bag Button-icon" aria-hidden="true" />
        <span className="Button-label">{target.label}</span>
      </a>,
      90
    );
  });
}
